module.exports = __webpack_public_path__ + "static/media/Naydalis P.efcee12c.jpg";